import type { FavouriteFilterId, FavouritesActions, FavouritesState } from '@web/contracts/Favourites';
import { MAX_FAVOURITES } from '@web/contracts/Favourites';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { userScopedStorage } from '../userScopedStorage';

export const STORAGE_KEY = 'firmable.favourites';

export const useFavourites = create<FavouritesState & FavouritesActions>()(
  persist(
    (set, get) => ({
      ids: [],
      add: (id) =>
        set((state) => {
          if (state.ids.includes(id)) return state;
          if (state.ids.length >= MAX_FAVOURITES) return state;
          return { ids: [...state.ids, id] };
        }),
      remove: (id) => set((state) => ({ ids: state.ids.filter((entry) => entry !== id) })),
      toggle: (id) => {
        const state = get();
        if (state.ids.includes(id)) state.remove(id);
        else state.add(id);
      },
      isFavourite: (id) => get().ids.includes(id),
      isAtCap: () => get().ids.length >= MAX_FAVOURITES,
      reset: () => set({ ids: [] }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => userScopedStorage),
      version: 1,
      partialize: (state) => ({ ids: state.ids }) as FavouritesState,
    },
  ),
);
